/* @flow */
import React from 'react';
// $FlowIgnore
import { MdWeb } from 'react-icons/md';

export default function ReadGroupIcon({
  style
}: Object): React.Element {
  return <MdWeb style={{color: 'skyblue', ...style}} />;
}
